import styled from 'styled-components';

/**
 * Badge de status (Ativo/Inativo)
 * Aceita prop 'active' para determinar cor
 */
export const StatusBadge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    font-family: 'Mulish', sans-serif;
    ${({ active }) =>
        active
            ? `
        background: rgba(39, 174, 96, 0.1);
        color: #27ae60;
    `
            : `
        background: rgba(231, 76, 60, 0.1);
        color: #e74c3c;
    `}
`;

/**
 * Badge de conexão (Conectado/Desconectado)
 * Aceita prop 'connected' para determinar cor
 */
export const ConnectionBadge = styled.span`
    display: inline-block;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    font-family: 'Mulish', sans-serif;
    ${({ connected }) =>
        connected
            ? `
        background: rgba(52, 152, 219, 0.1);
        color: #3498db;
    `
            : `
        background: rgba(149, 165, 166, 0.1);
        color: #95a5a6;
    `}
`;

/**
 * Status de conexão no header de formulários
 * Aceita prop 'connected' para determinar cor
 */
export const ConnectionStatus = styled.div`
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    ${({ connected }) =>
        connected
            ? `
        background: rgba(39, 174, 96, 0.1);
        color: #27ae60;
    `
            : `
        background: rgba(231, 76, 60, 0.1);
        color: #e74c3c;
    `}
`;

/**
 * Badge genérico customizável
 * Aceita props: color, backgroundColor
 */
export const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    padding: ${(props) => props.padding || '6px 12px'};
    border-radius: ${(props) => props.borderRadius || '20px'};
    font-size: ${(props) => props.fontSize || '12px'};
    font-weight: ${(props) => props.fontWeight || '600'};
    font-family: 'Mulish', sans-serif;
    background: ${(props) => props.backgroundColor || 'rgba(102, 126, 234, 0.1)'};
    color: ${(props) => props.color || '#667eea'};
`;

/**
 * Badge de sucesso
 */
export const SuccessBadge = styled(Badge)`
    background: rgba(39, 174, 96, 0.1);
    color: #27ae60;
`;

/**
 * Badge de erro
 */
export const ErrorBadge = styled(Badge)`
    background: rgba(231, 76, 60, 0.1);
    color: #e74c3c;
`;

/**
 * Badge de aviso
 */
export const WarningBadge = styled(Badge)`
    background: rgba(243, 156, 18, 0.1);
    color: #f39c12;
`;

/**
 * Badge de informação
 */
export const InfoBadge = styled(Badge)`
    background: rgba(52, 152, 219, 0.1);
    color: #3498db;
`;
